import { render } from "./upload_template.html?vue&type=template&id=2b7d1cec&external"
import script from "./upload_template?vue&type=script&lang=js&external"
export * from "./upload_template?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__